import {
    BackOfficeProviderBulkValuationReportDispatcher,
    BackOfficeProvidersDispatcher,
    CompanyDispatcher,
    CompanyFsaPermissionsDispatcher,
    CompanyInstructionDispatcher,
    CompanyServicePropositionDispatcher,
    CompanyWizardDispatcher,
} from "../Stores/Variable";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { FirmInstructionHistoryClient } from "../../../../../Wrap/Api/Company/FirmInstructionHistory";
import { GetFirmInstructionsQuery } from "../../../../../Wrap/Models/Models/Company/GetFirmInstructionsQuery";
import { CancelFirmInstructionsQuery } from "../../../../../Wrap/Models/Models/Company/CancelFirmInstructionsQuery";
import { FirmInstructionCancelClient } from "../../../../../Wrap/Api/Company/FirmInstructionCancel";
import { FirmInstructionCreateClient } from "../../../../../Wrap/Api/Company/FirmInstructionCreate";
import { CreateFirmInstructionQuery } from "../../../../../Wrap/Models/Models/Company/CreateFirmInstructionQuery";
import { FirmProcessType } from "../../../../../Wrap/Constants/Enums/Domain/FirmProcessType";
import { FirmInstructionClient } from "../../../../../Wrap/Api/Company/FirmInstruction";
import { UpdateFirmInstructionQuery } from "../../../../../Wrap/Models/Models/Company/UpdateFirmInstructionQuery";
import { FirmInstructionUpdateClient } from "../../../../../Wrap/Api/Company/FirmInstructionUpdate";
import { FirmInstructionSubmitClient } from "../../../../../Wrap/Api/Company/FirmInstructionSubmit";
import { FirmType } from "../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { CompanySearchClient } from "../../../../../Wrap/Api/Company/CompanySearch";
import { CompanyViewClient } from "../../../../../Wrap/Api/Company/CompanyView";
import { NetworkHistoryClient } from "../../../../../Wrap/Api/Network/NetworkHistory";
import { NetworkHistoryPaginatedModel } from "../../../../../Wrap/Models/Models/Network/NetworkHistoryPaginatedModel";
import { Promise } from "../../../../../react-core/Async/Promise";
import { FsaAuthorizationNumberCheckClient } from "../../../../../Wrap/Api/Company/FsaAuthorizationNumberCheck";
import { EdiMailBoxClient } from "../../../../../Wrap/Api/Company/EdiMailBox";
import { BackOfficeProvidersClient } from "../../../../../Wrap/Api/BackOfficeIntegration/BackOfficeProviders";
import { BackOfficeProviderBulkValuationReportClient } from "../../../../../Wrap/Api/BackOfficeIntegration/BackOfficeProviderBulkValuationReport";
import { CompanyServicePropositionClient } from "../../../../../Wrap/Api/Company/CompanyServiceProposition";
import { NextPaymentDateClient } from "../../../../../Wrap/Api/Payments/NextPaymentDate";
import { IJsonDate } from "../../../../../Wrap/System/IJsonDate";
import { FrequencyType } from "../../../../../Wrap/Constants/Enums/Domain/FrequencyType";
import { FsaSourcedCompanyDetailsClient } from "../../../../../Wrap/Api/Company/FsaSourcedCompanyDetails";
import { CompanyFsaPermissionsClient } from "../../../../../Wrap/Api/Company/CompanyFsaPermissions";
import { CompanyDetail } from "../../../../../Wrap/Models/Models/Company/CompanyDetail";

export class CompanyWizardAction {
    public static getCompanyWizardList(query: GetFirmInstructionsQuery): void {
        const client = new FirmInstructionHistoryClient();
        const promise = client.get(
            query.Statuses,
            query.FirmProcessType,
            query.FirmType,
            query.FirmName,
            query.TradingReference,
            query.PostCode,
            query.CreateUserId,
            query.StartedFromDate,
            query.StartedToDate,
            query.UpdatedFromDate,
            query.UpdatedToDate,
            query.Start,
            query.Count
        );
        promise.onSuccess((data) => {
            CompanyWizardDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {});
    }

    public static deleteCompanyWizardList(query: CancelFirmInstructionsQuery, callback?: () => void): void {
        const client = new FirmInstructionCancelClient();
        const promise = client.post(query);
        promise.onSuccess((data) => {
            if (data.length == 0) {
                CompanyWizardDispatcher.dispatch({
                    actionType: ActionType.Update,
                });
            } else {
                CompanyWizardDispatcher.dispatch({
                    actionType: ActionType.Error,
                });
            }
            callback();
        });

        promise.onError((err) => {
            CompanyWizardDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static firmCreate(type: FirmType, companyId: string, callback?): void {
        // TODO: REMOVE THIS CONDITION
        type = type == FirmType.Bond || type == FirmType.Pension ? FirmType.AppointedRepresentative : type;
        //
        const client = new FirmInstructionCreateClient();
        let query: CreateFirmInstructionQuery = null;
        if (companyId) {
            query = {
                HierarchyId: companyId,
                FirmProcessType: FirmProcessType.EditFirm,
            };
        } else {
            query = {
                FirmType: Number(type),
                FirmProcessType: FirmProcessType.FirmSetup,
            };
        }
        const promise = client.post(query);
        promise.onSuccess((data) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) {callback(data);}
        });

        promise.onError((err) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getFirmInstruction(instructionId: string | number): void {
        const client = new FirmInstructionClient();
        const promise = client.get(Number(instructionId));
        promise.onSuccess((data) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getFsaSourcedCompanyDetail(fsaNumber: string, callback: (data) => void): void {
        const client = new FsaSourcedCompanyDetailsClient();
        const promise = client.get(fsaNumber);
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static getCompanyFsaPermissionDetail(company: string, callback?: (data) => void): void {
        CompanyFsaPermissionsDispatcher.dispatch({
            actionType: ActionType.Loading,
            query: company,
        });

        const client = new CompanyFsaPermissionsClient();
        const promise = client.get(company);
        promise.onSuccess((data) => {
            CompanyFsaPermissionsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
                query: company,
            });

            if (callback) {
                callback(data);
            }
        });
    }

    public static cancelFirmInstruction(instructionId: string | number, callback: VoidFunction): void {
        const client = new FirmInstructionCancelClient();
        const promise = client.post({ InstructionIds: [Number(instructionId)] });
        promise.onSuccess((data) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Update,
                payload: data,
            });
            if (callback) {
                callback();
            }
        });

        promise.onError((err) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static submitFirmInstruction(id: number | string, callback?) {
        const client = new FirmInstructionSubmitClient();
        const promise = client.post(Number(id));
        promise.onSuccess((data) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Update,
                payload: data,
            });
            if (callback) {
                callback();
            }
        });

        promise.onError((err) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static updateFirmInstruction(query: UpdateFirmInstructionQuery, callback?: (data) => void): void {
        const client = new FirmInstructionUpdateClient();
        const promise = client.post(query);
        promise.onSuccess((data) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Update,
                payload: data,
            });
            if (callback) {
                callback(data);
            }
        });

        promise.onError((err) => {
            CompanyInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getFirm(query, callback?) {
        const client = new CompanySearchClient();
        const promise = client.get(
            query.CompanyId,
            query.CompanyName,
            query.FirmType,
            query.FSAAuthorisationNumber,
            query.Network,
            query.Postcode,
            query.SortDescending,
            query.Start,
            query.Count,
            query.OrderBy,
            query.IncludeInactive
        );
        promise.onSuccess((data) => {
            CompanyDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) {
                callback(data);
            }
        });

        promise.onError((err) => {
            CompanyDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getViewCompany(id: string, callback?: (com: CompanyDetail) => void) {
        const client = new CompanyViewClient();
        const promise = client.get(id);

        promise.onSuccess((data) => {
            if (callback) {
                callback(data);
            }
            CompanyDispatcher.dispatch({
                actionType: ActionType.Update,
                payload: data,
            });
        });

        promise.onError((err) => {
            CompanyDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getNetwork(query: any): Promise<NetworkHistoryPaginatedModel, any> {
        const client = new NetworkHistoryClient();
        return client.get(
            query.NetworkId,
            query.NetworkType,
            query.NetworkName,
            query.TradingReference,
            query.PostCode,
            false,
            query.Max,
            query.Min
        );
    }

    public static check(fsaAuthorizationNumber: string, callback) {
        const client = new FsaAuthorizationNumberCheckClient();
        const promise = client.get(fsaAuthorizationNumber);
        promise.onSuccess((data) => {
            callback(data);
        });

        promise.onError((err) => {
            CompanyDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getCompanyServicePropositions(actorId: number): void {
        const client = new CompanyServicePropositionClient();
        const promise = client.get(actorId, "");
        promise.onSuccess((data) => {
            CompanyServicePropositionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            CompanyServicePropositionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getEdiMailBoxIds(callback) {
        const client = new EdiMailBoxClient();
        const promise = client.get();
        promise.onSuccess((data) => {
            callback(data);
        });

        promise.onError((err) => {
            CompanyDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getBackOfficeProviders() {
        const client = new BackOfficeProvidersClient();
        client
            .get()
            .onSuccess((data) =>
                BackOfficeProvidersDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: data,
                })
            )
            .onError((err) => {
                BackOfficeProvidersDispatcher.dispatch({
                    actionType: ActionType.Error,
                    payload: err,
                });
            });
    }

    public static getBackOfficeProviderBulkValuationReports(
        bulkFileTypeId: number,
        networkId: number,
        companyCode: string,
        fromDate: IJsonDate,
        toDate: IJsonDate
    ) {
        const client = new BackOfficeProviderBulkValuationReportClient();
        const promise = client.get(bulkFileTypeId, networkId, companyCode, fromDate, toDate);
        promise.onSuccess((data) =>
            BackOfficeProviderBulkValuationReportDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            })
        );
        promise.onError((err) => {
            BackOfficeProviderBulkValuationReportDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getNextPaymentDate(asat: IJsonDate, frequency: FrequencyType, callback) {
        const client = new NextPaymentDateClient();
        const promise = client.get(asat, frequency);
        promise.onSuccess((data) => {
            callback(data);
        });
    }
}
